import { forwardRef, useImperativeHandle, useRef } from 'react';
import type { UploadProps } from 'antd';
import { DropdownUpload } from './DropdownUpload';

export interface ProgrammaticUploadRef {
  startUpload: () => unknown;
}

export const ProgrammaticUpload = forwardRef<
  ProgrammaticUploadRef,
  UploadProps
>((props, ref) => {
  const { style, ...rest } = props;
  const captureRef = useRef<HTMLSpanElement | null>(null);

  useImperativeHandle(
    ref,
    () => ({
      startUpload: () => {
        captureRef.current?.click();
      },
    }),
    [],
  );

  return (
    <DropdownUpload {...rest} style={{ ...style, display: 'none' }}>
      <span ref={captureRef} />
    </DropdownUpload>
  );
});
